var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Section',{staticClass:"banner",attrs:{"width":"lg"}},[_c('img',{attrs:{"src":require("@/assets/images/404.png"),"alt":"Compinero.com"}}),_vm._v(" "),_c('div',{staticClass:"button"},[_c('nuxt-link',{staticClass:"btn btn-orange btn-lg",attrs:{"to":"/"}},[_vm._v("\n            Take me back\n        ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }